import { render } from "./AdminNieuwsBrief.vue?vue&type=template&id=56483712"
import script from "./AdminNieuwsBrief.vue?vue&type=script&lang=js"
export * from "./AdminNieuwsBrief.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__